import ThreeColumnLayout from '../form-elements/ThreeColumnLayout';
import TwoColumnLayout from '../form-elements/TwoColumnLayout';
import { ItemsTypes } from '../toolbar';

export const mapItemTypeToContainerFormElement = {
  [ItemsTypes.TwoColumnLayout]: TwoColumnLayout,
  [ItemsTypes.ThreeColumnLayout]: ThreeColumnLayout,
};
